import { connect } from 'react-redux';
import { changeView as _changeView } from '../../../../actions/view';
import { authenticate as _authenticate, changePassword as _changePassword } from '../../../../actions/authentication';
import { LoginForm } from './index';

function mapStateToProps(state) {
  return {
    authentication: state.authentication
  };
}

function mapDispatchToProps(dispatch) {
  return {
    changePassword: function changePassword(password) {
      return dispatch(_changePassword(password));
    },
    changeView: function changeView(view) {
      return dispatch(_changeView(view));
    },
    authenticate: function authenticate(persistent) {
      return dispatch(_authenticate({
        persistent: persistent
      }));
    }
  };
}

export var LoginFormContainer = connect(mapStateToProps, mapDispatchToProps)(LoginForm);